module.exports = __webpack_public_path__ + "img/circle-microphone-lines.1f12da81.svg";